import { store } from "@app/store";
import { ErrorBoundary } from "@components/ErrorBoundary";
import React from "react";
import { Provider } from "react-redux";

interface AppProviderProps {
  children: React.ReactNode;
}

const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <Provider store={store}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </Provider>
  );
};

export default AppProvider;
